module.exports = __webpack_public_path__ + "img/903-309ba6.png";